<template>
    <div class="listing-detail-banner classic" ref="banner" :style="rootStyle">
        <!-- mobile top banner start -->
        <template v-if="isMobileSize">
            <div class="save-share-container" v-sticky="{ class: 'fixed' }">
                <div class="left-btn" @click="putAway">
                    <span class="btn-putAway iconfont icon-boldarrow"></span>
                    <span class="btn-text">{{
                        $t('md-detail-info.search')
                    }}</span>
                </div>
                <div class="right-btn">
                    <shake-animate>
                        <template #default="shakeStyle">
                            <div
                                class="item save"
                                :class="[!hasFavor && shakeStyle.animate]"
                                @click="onFavClick"
                                v-if="!isSoldHouse"
                            >
                                <span
                                    class="iconfont"
                                    :class="[
                                        hasFavor && !!user
                                            ? 'icon-heart-fill'
                                            : 'icon-heart'
                                    ]"
                                ></span>
                            </div>
                        </template>
                    </shake-animate>
                    <div class="item share" v-if="notApp" @click="sharePop">
                        <span class="iconfont icon-big-normal-share"></span>
                    </div>
                </div>
            </div>
        </template>
        <!-- mobile top banner start -->

        <!-- pc top banner start -->
        <div class="banner-top mg-container" ref="bannerTop">
            <div class="house-info">
                <div class="address">
                    <Addr tag="h1" theme="big-font" />
                    <house-tag
                        v-bind="infoFlag.exclusiveTag"
                        v-if="!isMobileSize && infoFlag.exclusiveTag"
                        theme="v1"
                    />
                    <house-tag
                        v-bind="infoFlag.tag"
                        v-if="infoFlag.tag"
                        theme="v1"
                    />
                    <house-tag theme="v1" v-if="infoFlag.onMarketTag" v-bind="infoFlag.onMarketTag" />
                </div>
                <div class="time-info" v-if="!isSoldHouse">
                    <only-client class="update-time" v-if="showUpdateAndDay">
                        {{ $t('md-detail-info.updated') }}
                        {{
                            $ft.formatDate(
                                info.updateTimeLong,
                                'MM/dd/yyyy hh:mm p'
                            )
                        }}
                    </only-client>
                    <span class="onsite">
                        <only-client>{{ createTime() }}</only-client>
                    </span>
                </div>
                <div class="time-info" v-else>
                    <span class="update-time">{{ soldDate }}</span>
                </div>
            </div>
            <div
                class="banner-left"
                v-if="prevAndNext.show && !isMobileSize && !showFixedBanner"
            >
                <template v-if="prevAndNext.canPrev">
                    <a
                        class="btn"
                        :href="prevAndNext.prevHref || null"
                        self="true"
                        rel="noopener noreferrer"
                    >
                        <span class="iconfont icon-next-big prev"></span>
                        <span class="text">{{
                            $t('md-detail-info.prev')
                        }}</span>
                    </a>
                    <div class="bg-img-box">
                        <site-img :src="prevAndNext.prevImg" class="bg-img" />
                    </div>
                </template>
            </div>
            <div
                class="banner-right"
                v-if="prevAndNext.show && !isMobileSize && !showFixedBanner"
            >
                <template v-if="prevAndNext.canNext">
                    <a
                        class="btn"
                        :href="prevAndNext.nextHref || null"
                        self="true"
                        rel="noopener noreferrer"
                    >
                        <span class="text">
                            {{ $t('md-detail-info.next') }}
                        </span>
                        <span class="iconfont icon-next-big next"></span>
                    </a>
                    <div class="bg-img-box">
                        <site-img :src="prevAndNext.nextImg" class="bg-img" />
                    </div>
                </template>
            </div>
        </div>
        <!-- pc top banner end -->

        <!-- pc top fixed banner start -->
        <template v-if="!isMobileSize">
            <div
                class="fixed-banner"
                :class="{ fixed: showFixedBanner }"
                :style="fixedBannerStyle"
            >
                <div class="banner-box mg-container">
                    <div class="banner-left" v-if="prevAndNext.show">
                        <template v-if="prevAndNext.canPrev">
                            <a
                                class="btn"
                                :href="prevAndNext.prevHref || null"
                                self="true"
                                rel="noopener noreferrer"
                            >
                                <span
                                    class="iconfont icon-next-big prev"
                                ></span>
                                <span class="text">{{
                                    $t('md-detail-info.prev')
                                }}</span>
                            </a>
                            <div class="bg-img-box">
                                <site-img
                                    :src="prevAndNext.prevImg"
                                    class="bg-img"
                                />
                            </div>
                        </template>
                    </div>
                    <div class="center mg-container">
                        <div class="price-address">
                            <price class="price" />
                            <Addr />
                        </div>
                        <div class="save-share-tour">
                            <shake-animate>
                                <template #default="shakeStyle">
                                    <span
                                        class="item save"
                                        @click="onFavoriteClick"
                                        v-if="!isSoldHouse"
                                        :class="[
                                            hasFavor ? 'active' : '',
                                            !hasFavor && shakeStyle.animate
                                        ]"
                                    >
                                        <i
                                            class="iconfont icon-heart default"
                                        ></i>
                                        <i
                                            class="iconfont icon-heart-fill hover"
                                        ></i>
                                        <span class="btn-text">{{
                                            $t('md-detail-info.save')
                                        }}</span>
                                    </span>
                                </template>
                            </shake-animate>
                            <span class="item share">
                                <i
                                    class="iconfont icon-v2-share-Normal default"
                                ></i>
                                <!-- hover share icon -->
                                <i
                                    class="iconfont icon-v2-share-hover hover"
                                ></i>
                                <span class="btn-text">{{
                                    $t('md-detail-info.share')
                                }}</span>
                                <share-popper
                                    class="popper"
                                    :shares="shares"
                                    :theme="theme"
                                    :listingId="info.id"
                                />
                            </span>
                            <span
                                @click="schedulePop"
                                class="item tour"
                                v-if="!isSoldHouse"
                            >
                                <span class="text">{{
                                    $t('md-detail-info.scheduleATour')
                                }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="banner-right" v-if="prevAndNext.show">
                        <template v-if="prevAndNext.canNext">
                            <a
                                class="btn"
                                :href="prevAndNext.nextHref || null"
                                self="true"
                                rel="noopener noreferrer"
                            >
                                <span class="text">{{
                                    $t('md-detail-info.next')
                                }}</span>
                                <span
                                    class="iconfont icon-next-big next"
                                ></span>
                            </a>
                            <div class="bg-img-box">
                                <site-img
                                    :src="prevAndNext.nextImg"
                                    class="bg-img"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <!-- pc top fixed banner end -->
        <bread-crumb
            v-if="!isMobileSize && !wordPressSSR"
            theme="classic"
            :detailInfo="info"
        />
        <Swiper
            class="detail-info-imgs"
            :class="{ 'align-center': allImages.length < slidesPerView }"
            trackSource="detail-info-img"
            v-bind="options"
            @init="onSwiperReady"
            ref="swiper"
            @slideChange="handleSlideChange"
        >
            <Slide
                :key="index"
                :class="'slide-' + item.length"
                v-for="(item, index) in allImages"
            >
                <div class="swiper-box" @click="touched(index, $event, item)">
                    <div class="swiper-video" v-if="item.type == '3d'">
                        <img-box
                            :src="item.preview"
                            :alt="videoImgAlt"
                        />
                    </div>
                    <img-box
                        v-else
                        @load="onImgLoad(index, $event)"
                        :lazy="lazyload"
                        :src="item"
                        :alt="imgAlt"
                        class="swiper-img"
                    >
                        <template v-if="isMobileSize && infoFlag.exclusiveTag">
                            <house-tag
                                v-bind="infoFlag.exclusiveTag"
                                theme="v1"
                            />
                        </template>
                    </img-box>
                </div>
            </Slide>
            <div class="swiper-button-prev iconfont icon-prev disabled"></div>
            <div class="swiper-button-next iconfont icon-next"></div>
        </Swiper>
        <PSwp
            :options="photoswipeOption"
            ref="pswp"
            defaultSize="1200x750"
            trackSource="detail-info-img"
        />
        <div
            v-if="allImages.length > 1"
            class="pagination pc"
            @click="touched()"
            style="cursor: pointer"
        >
            {{ $t('md-detail-info.seeAllPhotos', { count: allImages.length }) }}
        </div>
        <div
            v-if="allImages.length > 1"
            @click="touched(0)"
            class="pagination mobile"
        >
            {{
                $t('md-detail-info.photo', {
                    count:
                        curPage == 0
                            ? allImages.length
                            : curPage + '/' + allImages.length,
                    interpolation: {
                        escapeValue: false
                    }
                })
            }}
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import common from '../banner.js';
import { dateFormat } from '../../../common/format';
import price from './detail-info-header/price.vue';
import shakeAnimate from '../shake-animate.vue';
import houseTag from '@/modules/md-house/_component/house-tag';
import Addr from '../_components/address.vue';
export default {
    mixins: [common],
    inject: ['onFavoriteClick', 'createTime'],
    components: { price, shakeAnimate, houseTag, Addr },
    data: function() {
        return {
            speed: 1000,
            theme: 'classic',
            showFixedBanner: false,
            soldDate: ''
        };
    },
    computed: {
        ...mapState({
            info: store => store.listingDetail.info || {},
            prevAndNext: store => store.prevAndNext,
            hasFavor: store => store.hasFavor,
            infoFlag: store => store.infoFlag
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        slidesPerView() {
            return this.isMobileSize ? 1 : 3;
        },
        rootStyle() {
            return this.isMobileSize
                ? {
                    'max-width': '100vw'
                }
                : // fix AM-298689
                { 'min-height': '400px' };
        }
    },
    mounted() {
        global.scroll(this.onScroll);
        let time = dateFormat(
            'MM/dd/yyyy',
            new Date(this.info.soldDate),
            this.$pinia
        );
        if (this.info.statusOrigin == 'Leased') {
            this.soldDate = this.$t('md-detail-info.leasedDate', { time });
        } else {
            this.soldDate = this.$t('md-detail-info.soldDateTime', { time });
        }
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    },
    methods: {
        onScroll() {
            let bannerTop = this.$refs.bannerTop;
            if (!bannerTop) {
                return; 
            }
            let rect = bannerTop.getBoundingClientRect();
            if (rect.top < 0) {
                this.showFixedBanner = true;
            } else {
                this.showFixedBanner = false;
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';

.listing-detail-banner.classic {
    width: 100%;
    // overflow: hidden;
    position: relative;
    .mls-provided.mg-container {
        line-height: 20px;
        font-size: 14px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 10px;
        color: #fff;
        z-index: 10;
        &.margin {
            right: 40px;
        }
        @include media-600 {
            width: calc(100% - 120px);
            left: 0;
            transform: translateX(0);
        }
    }
    .banner-schedule {
        cursor: initial;
        padding-top: 10px;
        visibility: hidden;
        max-width: 350px;
        position: absolute;
        right: 0;
        top: 100%;
        z-index: 3;
        font-family: var(--font-normal);
        text-align: left;
        &:not(.appointment) {
            width: 350px;
        }
    }
    .detail-info-imgs {
        width: 100%;
        height: 400px;
        overflow: hidden;
        &.align-center .swiper-wrapper {
            justify-content: center;
        }
        .swiper-button-prev,
        .swiper-button-next {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            font-size: 35px;
            height: 100%;
            width: 100px;
            color: rgba(255, 255, 255, 0.6);
            opacity: 0.6;
            cursor: pointer;
            &:hover {
                background-image: linear-gradient(
                    90deg,
                    rgba(0, 0, 0, 0.6),
                    transparent
                );
                color: white;
            }
            &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            &::after {
                display: none;
            }
            &.swiper-button-disabled {
                opacity: 0.35;
            }
        }
        .swiper-button-prev {
            left: 0;
        }
        .swiper-button-next {
            right: 0;
            &:hover {
                background-image: linear-gradient(
                    270deg,
                    rgba(0, 0, 0, 0.6),
                    transparent
                );
            }
        }
        .swiper-slide {
            height: 100%;
            display: flex;
        }
        .swiper-box {
            height: 100%;
            width: 100%;
            .swiper-img {
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                    cursor: pointer;
                }
            }
            .img-box {
                .house-status {
                    position: absolute;
                    left: 15px;
                    top: 15px;
                }
            }
            .swiper-video {
                height: 100%;
                position: relative;
                background: black;
                .play {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: url('//static.chimeroi.com/site3/images/play.png');
                    background-size: cover;
                    height: 60px;
                    width: 60px;
                }
                .img-box {
                    height: 100%;
                    cursor: pointer;
                }
            }
        }
    }
    .pagination {
        &.mobile {
            display: none;
        }
        position: absolute;
        right: 16px;
        bottom: 10px;
        padding: 0px 6px;
        background-color: rgba(17, 17, 17, 0.4);
        font-size: 14px;
        color: #fff;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 1px;
        z-index: var(--level-low);
        &.pc {
            cursor: pointer;
        }
    }
    .fixed-banner {
        .center .price-address .price {
            .price-value,
            .sold-price {
                font-size: 28px;
            }
        }
    }

    .save-share-container {
        padding: 0 15px;
        height: 51px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        &.fixed {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 100;
        }
        .left-btn {
            color: #282828;
            .btn-putAway {
                transform: rotate(180deg);
                display: inline-block;
            }
            .iconfont {
                font-size: 18px;
            }
            .btn-text {
                margin-left: 3px;
                font-size: 18px;
            }
        }
        .right-btn {
            .item {
                margin-right: 20px;
                display: inline-block;
                &:last-of-type {
                    margin-right: 0;
                }

                &.save {
                    color: #f0454c;
                    .iconfont {
                        font-size: 20px;
                    }
                }
                &.share {
                    color: #515666;
                    .iconfont {
                        font-size: 22px;
                    }
                }
            }
        }
    }
    .banner-top {
        padding: 15px 0;
        background-color: #ffffff;
        display: flex;
        .house-info {
            width: 200px;
            flex: 1;
            .address {
                margin-bottom: 5px;
                font-size: 0;
                .address-container {
                    display: inline;
                }
                .city {
                    margin-right: 15px;
                }
                .house-status {
                    vertical-align: text-bottom;
                    margin-bottom: -3px;
                    & + .house-status {
                        margin-left: 5px;
                    }
                }
            }
            .time-info {
                font-size: 14px;
                color: #a8a8a8;
                .update-time,
                .onsite {
                    line-height: 20px;
                }
                .onsite {
                    margin-left: 12px;
                }
            }
        }
        .banner-left,
        .banner-right {
            width: 120px;
            flex-shrink: 0;
            flex-grow: 0;
            @media screen and (max-width: 1230px) {
                display: none;
            }
            .bg-img,
            .bg-img-box {
                width: 90px;
                height: 60px;
                position: relative;
            }
            .bg-img-box {
                opacity: 0;
                &:after {
                    content: '';
                    position: absolute;
                    width: 90px;
                    height: 60px;
                    top: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.1);
                }
                .bg-img {
                    width: 90px;
                    height: 60px;
                    display: inline-block;
                }
            }
            a.btn {
                color: #191919;
                position: absolute;
                height: 30px;
                width: 90px;
                border-radius: 2px;
                text-align: center;
                border: solid 1px #eaeaea;
                font-size: 14px;
                line-height: 29px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 10;
                display: block;
                &:hover {
                    cursor: pointer;
                    border: none;
                    color: #ffffff;
                    line-height: 25px;
                    + .bg-img-box {
                        opacity: 1;
                    }
                }
                .iconfont {
                    font-size: 12px;
                    &.prev {
                        transform: rotate(180deg);
                        display: inline-block;
                    }
                }
            }
        }
        .prev-next {
            height: 30px;
            line-height: 30px;
            background: white;
            font-size: 14px;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 7px 20px;
            .iconfont {
                font-weight: 600;
                font-size: 12px;
            }
            &.prev {
                border: 1px solid #cbcbcb;
                color: #191919;
            }
            &.next {
                border: 1px solid #eaeaea;
                color: #a8a8a8;
            }
        }
    }
    // pc top fixed banner
    .fixed-banner {
        width: 100%;
        min-height: 80px;
        padding: 10px 0;
        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
        background-color: #ffffff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: var(--level-medium);
        opacity: 0;
        visibility: hidden;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        transition: all 0.3s ease;
        &.fixed {
            visibility: visible;
            opacity: 1;
        }
        .banner-box {
            margin: 0 auto;
            display: flex;
            justify-content: center;
            @media (min-width: 1210px) {
                .center {
                    margin: 0;
                }
            }
            .banner-left,
            .banner-right {
                width: 90px;
                padding: 0;
                position: relative;
                .bg-img-box {
                    opacity: 0;
                    &:after {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 60px;
                        top: 0;
                        left: 0;
                        background-color: rgba(0, 0, 0, 0.1);
                    }
                    .bg-img {
                        width: 90px;
                        height: 60px;
                        display: inline-block;
                    }
                }
                .btn {
                    color: #191919;
                    position: absolute;
                    height: 30px;
                    width: 100%;
                    border-radius: 2px;
                    text-align: center;
                    font-size: 14px;
                    line-height: 29px;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    display: block;
                    &:hover {
                        cursor: pointer;
                        border: none;
                        color: #ffffff;
                        line-height: 25px;
                        + .bg-img-box {
                            opacity: 1;
                        }
                    }
                    .iconfont {
                        font-size: 12px;
                        &.prev {
                            transform: rotate(180deg);
                            display: inline-block;
                        }
                    }
                }
            }
            .center {
                display: flex;
                justify-content: space-between;
                align-items: center;
                &.mg-container {
                    &:after {
                        content: none;
                    }
                    @media (max-width: 1209px) {
                        width: auto;
                        flex: 1;
                        margin: 0;
                    }
                }
                .price-address .price .price-value {
                    font-size: 28px;
                }
                .address {
                    max-width: 600px;
                    @media (max-width: 1209px) {
                        max-width: 400px;
                    }
                }
                .save-share-tour {
                    > .item {
                        cursor: pointer;
                        text-align: center;
                        display: inline-block;
                        height: 40px;
                        margin-right: 30px;
                        &:last-child {
                            margin-right: 0;
                        }
                        .btn-text {
                            font-size: 12px;
                            color: #787878;
                            line-height: 2;
                        }
                        > .iconfont {
                            font-size: 18px;
                            display: block;
                        }
                        &:hover {
                            .btn-text {
                                color: #191919;
                            }
                        }
                        &.save {
                            .iconfont {
                                color: #f0454c;
                            }
                            .hover {
                                display: none;
                            }
                            &.active,
                            &:hover {
                                .default {
                                    display: none;
                                }
                                .hover {
                                    display: block;
                                }
                            }
                        }
                        &.share {
                            position: relative;
                            .iconfont {
                                color: #515666;
                            }
                            .default {
                                display: block;
                            }
                            .hover {
                                display: none;
                            }
                            &:hover {
                                .popper {
                                    visibility: visible;
                                }
                                .default {
                                    display: none;
                                }
                                .hover {
                                    display: block;
                                    color: #348cff;
                                }
                            }
                            .popper {
                                position: absolute;
                                top: 100%;
                                left: 50%;
                                padding-top: 15px;
                                z-index: var(--level-medium);
                                transform: translateX(-50%);
                                visibility: hidden;
                            }
                        }
                        &.tour {
                            @include color-button-hover();
                            position: relative;
                            vertical-align: top;
                            padding: 10px 18px;
                            border-radius: 2px;
                            font-size: 16px;
                            font-family: var(--font-bold);
                            @include color-button();
                            &:hover {
                                .banner-schedule {
                                    visibility: visible;
                                }
                            }
                            .text {
                                display: inline-block;
                                max-width: 250px;
                                @include ellipsis();
                            }
                        }
                    }
                }
            }
            .banner-left {
                margin-right: 20px;
                .btn {
                    border: solid 1px #cbcbcb;
                }
            }
            .banner-right {
                margin-left: 20px;
                .btn {
                    border: solid 1px #eaeaea;
                }
            }
        }
    }
    @media (max-width: 600px) {
        .banner-top {
            margin-top: 20px;
            padding-top: 0;
            .house-info {
                margin: 0;
                .address {
                    color: #313b42;
                    .city {
                        margin-right: 10px;
                    }
                }
                .time-info {
                    font-size: 12px;
                    color: #a9a9a9;
                }
            }
            .prev,
            .next {
                display: none;
            }
        }
    }
}

@include media-600 {
    .listing-detail-banner.classic {
        margin-top: 0;
        .swiper.detail-info-imgs {
            height: 250px;
            .swiper-wrapper {
                .swiper-slide {
                    width: 100%;
                }
            }
        }
        .pagination {
            &.pc {
                display: none;
            }
            &.mobile {
                display: block;
            }
        }
    }
}

@mixin slideLeft() {
    width: 50%;
    flex: 1;
    height: 100%;
    margin-right: 2px;
}
</style>
